import React from 'react';

interface FilterSidebarProps {
	isOpen: boolean;
	toggleSidebar: () => void;
	setStartDate: (date: string) => void;
	setEndDate: (date: string) => void;
	setStartTime: (date: string) => void;
	setEndTime: (date: string) => void;
	applyFilters: () => void;
}

const FilterSidebar: React.FC<FilterSidebarProps> = ({
	isOpen,
	toggleSidebar,
	setStartDate,
	setEndDate,
	setStartTime,
	setEndTime,
	applyFilters, 
}) => {
	
	const handleApplyFilters = () => {
		applyFilters();

		toggleSidebar();
	};

	const handleReset = () => {
		setStartDate('');
		setEndDate('');
		setStartTime('');
		setEndTime('');
	};

	if (!isOpen) return null;

	return (
		<div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-end z-50">
			<div className="bg-white w-[400px] p-6 rounded-lg shadow-lg flex flex-col justify-between h-full">
				<div>
					<div className="flex justify-between items-center mb-6">
						<h3 className="text-lg font-semibold text-gray-900">Filter</h3>
						<button onClick={toggleSidebar} className="text-gray-500 hover:text-gray-900 p-2 rounded-full">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								fill="none"
								viewBox="0 0 24 24"
								stroke="currentColor"
								className="w-5 h-5"
							>
								<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
							</svg>
						</button>
					</div>
					<div className="mb-4">
						<label className="block text-sm text-gray-700">From Date</label>
						<div className="flex space-x-2">
							<input
								type="date"
								onChange={(e) => setStartDate(e.target.value)}
								className="block w-full p-2 text-sm border border-gray-300 rounded-md"
							/>
							<input
								type="time"
								onChange={(e) => setStartTime(e.target.value)}
								className="block w-full p-2 text-sm border border-gray-300 rounded-md"
							/>
						</div>
					</div>
					<div className="mb-4">
						<label className="block text-sm text-gray-700">To Date</label>
						<div className="flex space-x-2">
							<input
								type="date"
								onChange={(e) => setEndDate(e.target.value)}
								className="block w-full p-2 text-sm border border-gray-300 rounded-md"
							/>
							<input
								type="time"
								onChange={(e) => setEndTime(e.target.value)}
								className="block w-full p-2 text-sm border border-gray-300 rounded-md"
							/>
						</div>
					</div>
				</div>
				<div className="flex justify-end space-x-4">
					<button
						onClick={handleReset}
						className="px-4 py-2 text-sm text-gray-600 hover:text-gray-900 border border-gray-300 rounded-md"
					>
						Reset
					</button>
					<button
						onClick={handleApplyFilters}
						className="px-4 py-2 text-sm bg-blue-600 text-white rounded-md hover:bg-blue-700"
					>
						Apply
					</button>
				</div>
			</div>
		</div>
	);
};

export default FilterSidebar;